import { Loading } from '@aon/aon-tws-common-ui';
import React from 'react';
import { LoadingWrapper } from './LoadingWrapper';

type LoadingIndicatorProps = Partial<Pick<React.ComponentProps<typeof Loading>, 'height' | 'width'>> &
	Omit<React.ComponentProps<typeof Loading>, 'height' | 'width'>;

const LoadingIndicator = ({ height = '70px', width = '70px', ...props }: LoadingIndicatorProps) => (
	<LoadingWrapper>
		<Loading height={height} width={width} {...props} />
	</LoadingWrapper>
);
LoadingIndicator.displayName = 'LoadingIndicator';

export { LoadingIndicator, type LoadingIndicatorProps };
